<%- include('inc/common.js') %>
<%- include('inc/carousel.js') %>
<%- include('inc/accordion.js') %>
<%- include('inc/parallax.js') %>
<%- include('inc/entry.js') %>
<%- include('inc/fitie.js') %>
<%- include('inc/side_navi.js') %>
<%- include('inc/inview.js') %>
<%- include('inc/scroll_anime.js') %>
<%- include('inc/fv.js') %>
<%- include('inc/userAgent.js') %>
<%#- include('inc/training_modal.js') %>
<%- include('inc/scroll_onoff.js') %>